import React, { ReactElement, useEffect, useState } from "react";
import format from "date-fns/format";
import useSyncCheckState from "./useSyncCheckState.ts";
import { AccommodationIcon } from "../accommodation/AccommodationIcon.tsx";
import { SYNC_CHECK_CONSTANT } from "./SyncCheckConstant.ts";
import SyncCheck from "./SyncCheck.ts";

interface SyncCheckByAccommodationInterface {
    token: string;
    accommodation_id: number;
}

export const SyncCheckByAccommodation: React.FC<SyncCheckByAccommodationInterface> = ({ token, accommodation_id }) => {
    const [item, setItem] = useState<ReactElement[] | null>(null);
    const { syncChecks, sync_updated_at, isLoading, getSyncCheck, createSyncCheck } = useSyncCheckState();
    useEffect(() => {
        getSyncCheck(token, accommodation_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        console.log("isLoading changed", isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (sync_updated_at) {
            getSyncCheck(token, accommodation_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sync_updated_at]);

    const checkStatus = (m: number, rowId: string) => {
        createSyncCheck(token, accommodation_id, m);
    };
    const hasFutureBook = (syncCheck: SyncCheck) => {
        if (syncCheck.getErrorDays().length === 0) return true;
        const target_month_start_date = new Date(syncCheck.year, syncCheck.month - 1, 1);
        if (target_month_start_date.getTime() >= new Date().getTime()) return true;

        //日付の一番後ろの日を取得
        const last_error_day = syncCheck.getErrorDays()[syncCheck.getErrorDays().length - 1];
        if (last_error_day.getTime() < new Date().getTime()) return false;
        return true;
    };

    useEffect(() => {
        if (syncChecks) {
            setItem(
                syncChecks
                    .map((syncCheck, index) => {
                        if (syncCheck.status !== SYNC_CHECK_CONSTANT.RESULT_OK && hasFutureBook(syncCheck)) {
                            return (
                                <tr key={"check_log_" + syncCheck.created_at}>
                                    <td className="w-80 p-10 border-gray-light">
                                        <AccommodationIcon token={token} id={accommodation_id} />
                                    </td>
                                    <td className="p-10 border-gray-light">
                                        {syncCheck.year}年{syncCheck.month}月
                                    </td>
                                    <td className="p-10 border-gray-light">{syncCheck.room_name}</td>
                                    <td className="p-10 border-gray-light">{format(syncCheck.created_at, "yyyy/MM/dd HH:mm")}</td>
                                    <td className="p-10 border-gray-light">
                                        {syncCheck.getErrorDays().length > 0
                                            ? syncCheck.getErrorDays().map((day) => {
                                                  //今日以降であれば表示
                                                  if (day.getTime() < new Date().getTime()) return null;
                                                  return (
                                                      <div key={day.toString()}>
                                                          <a
                                                              href={
                                                                  "/m/accommodation/" +
                                                                  accommodation_id +
                                                                  "/book/" +
                                                                  syncCheck.year +
                                                                  "/" +
                                                                  syncCheck.month +
                                                                  "/" +
                                                                  format(day, "d")
                                                              }
                                                          >
                                                              {format(day, "d")}日
                                                          </a>
                                                      </div>
                                                  );
                                              })
                                            : "パスワードを確認してください"}
                                    </td>
                                    <td className="p-10 border-gray-light link">
                                        {isLoading ? (
                                            <span>🔄 Loading...</span>
                                        ) : (
                                            <span onClick={() => checkStatus(syncCheck.getDiffInMonth(), "check_log_" + index)}>再チェック</span>
                                        )}
                                    </td>
                                </tr>
                            );
                        } else {
                            return null;
                        }
                    })
                    .filter((syncCheck) => syncCheck !== null)
                // setItem(
            );
            // setItem(accommodation);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [syncChecks, isLoading]);

    return <>{item}</>;
};
